import { LoadingButton } from '@mui/lab'
import {TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup';

import { useFetch } from 'use-http'
import { MAIN_API_URL } from '../../../configuration'
import { Alert } from '@/components/ui'

const validationSchema = Yup.object({
    mail: Yup.string().email('Ingrese un correo electrónico válido').required('El correo electrónico es requerido'),
});

export const UserPasswordRecover = () => {
    const { post, loading, response } = useFetch(MAIN_API_URL);
    const query = new URLSearchParams(window.location.search);
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate('/');
    }

    const [errorMsg, setErrorMsg] = useState('');

    const formik = useFormik({
        initialValues: {
            mail: query.get('mail') || '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.mail = values.mail.toLowerCase().trim();
            const data = await post('/auth/request-password-reset', values)
            if (response.ok) {
                navigate('/password_reset/email_sent/' + values.mail)
            } else {
                setErrorMsg(data.msg)
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }
        }
    })

    useEffect(() => {
        if(errorMsg.length > 0) setErrorMsg('')
    }, [formik.values])


    return (
        <>
            <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="mail"
                label="Correo electrónico"
                name="mail"
                autoComplete="mail"
                autoFocus
                sx={{ margin: 0, fontFamily: 'Poppins' }}
                value={formik.values.mail}
                onChange={formik.handleChange}
                error={formik.touched.mail && Boolean(formik.errors.mail)}
                helperText={formik.touched.mail && formik.errors.mail}
            />
            {
                errorMsg.length > 0 &&
                <Alert variant="danger" className="w-full text-left py-2.5 px-3 text-[13px]">
                    {errorMsg}, por favor intente de nuevo.
                </Alert>
            }
            <LoadingButton
                variant="contained"
                loadingPosition="center"
                loading={loading}
                disabled={loading}
                loadingIndicator="Cargando..."
                sx={{
                    width: '100%',
                    height: '48px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    color: '#fff',
                    background: '#0DA15A',
                    boxShadow: '0 1px 2px rgba(13,161,90,.25), 0 6px 16px -6px rgba(13,161,90,.45)',
                    '&:hover': {
                        background: '#0A8449',
                        boxShadow: '0 2px 4px rgba(13,161,90,.3), 0 10px 22px -8px rgba(13,161,90,.5)',
                    },
                    '&.Mui-disabled': {
                        background: '#0DA15A',
                        color: '#fff',
                        opacity: 0.6,
                    },
                }}
                onClick={formik.handleSubmit}
            >
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.95rem', fontWeight: 600 }}>
                    Enviar correo electrónico
                </Typography>
            </LoadingButton>
            <Typography variant={'subtitle1'} sx={{ fontSize: '0.9rem', fontWeight: 400, cursor: 'pointer', alignSelf: 'center' }}>
                <span style={{ color: '#0DA15A', fontWeight: 600 }} onClick={handleBackClick}>Volver</span>
            </Typography>
        </>
    )
}